var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../assets/loading.svg"),"alt":"loading icon"}}),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }